import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const MarketingSupportCTA = () => {
  return (
    <div className="border rounded-lg overflow-hidden shadow-sm bg-gradient-to-br from-primary/5 to-primary/10 border-primary/20">
      <div className="p-6 md:p-8 lg:p-10">
        <div className="flex flex-col lg:flex-row items-center gap-6 lg:gap-8">
          <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0">
            <Icon name="Headphones" size={40} className="text-primary" />
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground mb-2">
              Need Marketing Support?
            </h2>
            <p className="text-sm md:text-base text-muted-foreground mb-4 max-w-2xl">
              Schedule a 1:1 consultation with our marketing experts to discuss content strategy, campaign planning, and best practices for your practice.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
              <Link to="/schedule-marketing-support">
                <Button
                  variant="default"
                  size="lg"
                  iconName="Calendar"
                  iconPosition="left"
                  fullWidth
                  className="sm:w-auto"
                >
                  Schedule Consultation
                </Button>
              </Link>
              <Button
                variant="outline"
                size="lg"
                iconName="MessageCircle"
                iconPosition="left"
                fullWidth
                className="sm:w-auto"
              >
                Contact Support
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketingSupportCTA;